import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import Blue_border_button from "../../common_btn/blue_border_button/Blue_border_button";
import "./Internship_Program_Details.css";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";
import { useState } from "react";
import Success_modal from "../../common_modal/success_modal/Success_modal";
import successAnimation from "../../../animation/success_lottie/Success_lottie.json";
const Internship_Program_Details = ({ data, onBack }) => {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);
  /* ================= CONFIG MAPS ================= */
  const contact = data.contacts?.[0];

  const internshipDetails = [
    { label: "Start Date", value: data.startDate },
    { label: "End Date", value: data.endDate },
    { label: "Work Hours", value: data.workHours },
    { label: "Vacancies", value: data.vacancies },
  ];

  const sections = [
    {
      title: "Benefits",
      type: "grid",
      data: data.benefits,
    },
    {
      title: "Requirements",
      type: "list",
      data: data.requirements,
    },
    {
      title: "Documents",
      type: "list",
      data: data.documents,
    },

    {
      title: "Contact",
      type: "grid",
      data: contact
        ? [
            { label: "HR / Supervisor Name", value: contact.name },
            { label: "HR / Supervisor Mail", value: contact.email },
          ]
        : [],
    },
  ];

  /* ================= RENDER ================= */

  return (
    <>
      <div className="">
        {/* Header */}
        <div className="detail_header">
          <Button className="back_btn" onClick={onBack}>
            <div className="back_icon_holder">
              <FontAwesomeIcon icon={faAngleLeft} />
            </div>
            Back
          </Button>
        </div>

        <div className="internship_detail_wrapper">
          <div className="detail_card">
            {/* Top Info */}
            <div className="detail_top">
              <div className="company_info">
                <div className="d-flex gap-3 align-items-center">
                  {data.logo && (
                    <img
                      src={data.logo}
                      alt="company"
                      className="internship_logo"
                    />
                  )}
                  <h5 className="company_name">{data.companyName}</h5>
                </div>

                <div className="location_div">
                  <h5 className="location">{data.location}</h5>
                  <img
                    src={data.flag}
                    alt="country-flag"
                    className="country_flag"
                  />
                </div>
              </div>
            </div>

            {/* Banner */}
            <div className="banner_wrapper">
              <img
                src={data.bannerImage}
                alt="program"
                className="banner_img"
              />
            </div>

            <div className="detail_card_body">
              {/* Title */}
              <div className="program_title_holder">
                <h4 className="program_title">{data.title}</h4>
                <p className="program_desc">{data.description}</p>
              </div>

              {/* Internship Details */}
              <div className="section">
                <h6 className="section_title">Internship Details</h6>
                <div className="grid">
                  <div className="row">
                    {internshipDetails.map((item, index) => (
                      <div className="col-lg-3" key={index}>
                        <h5 className="internship_label">{item.label}</h5>
                        <p className="internship_label_text">{item.value}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Dynamic Sections */}
            {sections.map((section, index) => (
              <div className="section" key={index}>
                <h6 className="section_title">{section.title}</h6>

                {/* Grid */}
                {section.type === "grid" && (
                  <div className="grid">
                    <div className="row">
                      {section.data.map((item, i) => (
                        <div className="col-lg-3" key={i}>
                          <h5 className="internship_label">{item.label}</h5>
                          <p className="internship_label_text">{item.value}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* List */}
                {/* {section.type === "list" && (
                <div className="form_holder">
                  <Form>
                    <ul>
                      {section.data.map((item, i) => (
                        <p className="internship_label_text">
                          <li key={i}>
                            {" "}
                            <Form.Check
                              label={item}
                              name="group1"
                              type={"radio"}
                            />{" "}
                          </li>
                        </p>
                      ))}
                    </ul>
                  </Form>
                </div>
              )} */}

                {section.type === "list" && (
                  <div className="form_holder">
                    <Form>
                      <ul>
                        {section.data.map((item, i) => (
                          <li key={i}>
                            <Form.Check type="checkbox" label={item} />
                          </li>
                        ))}
                      </ul>
                    </Form>
                  </div>
                )}

                {/* Contact */}
                {section.type === "contact" && (
                  <div className="row">
                    {section.data.map((contact, i) => (
                      <div className="col-lg-6" key={i}>
                        <div className="contact_holder">
                          <h5 className="internship_label">Name</h5>
                          <p className="internship_label_text">
                            {contact.name}
                          </p>

                          <h5 className="internship_label">Position</h5>
                          <p className="internship_label_text">
                            {contact.position}
                          </p>

                          <h5 className="internship_label">Email</h5>
                          <p className="internship_label_text">
                            {contact.email}
                          </p>

                          <h5 className="internship_label">Contact No</h5>
                          <p className="internship_label_text">
                            {contact.contact_no}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {/* Stipend */}
            <div className="section">
              <h6 className="section_title">Stipend</h6>
              <h2 className="stipend_label">{data.stipend}</h2>
            </div>

            {/* Actions */}
            <div className="bottom_btn_holder">
              <Blue_btn btn_text={"Apply Now"} />
              <Blue_border_button
                button_text={"Download Brochure"}
                onClick={() => setModalsuccessShow(true)}
              />
            </div>
          </div>
        </div>
      </div>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Downloading Brochure"}
        animationData={successAnimation}
      />
    </>
  );
};

export default Internship_Program_Details;
